import cx from "classnames";
import { cn } from "../../button.component";
export const PostTileType = {
  default: 0,
  comfortable: 1,
  compact: 2,
  expanded: 3,
};

/**
 * PostTileShimmer
 * @param {any} type
 */
function PostTileShimmer({ type = PostTileType.default, className = "" }) {
  let margin, padding;
  let displayThirdLine = true;

  switch (type) {
    case PostTileType.default:
      margin = "my-3";
      padding = "p-4";
      break;
    case PostTileType.comfortable:
      margin = "my-2";
      padding = "p-3";
      break;
    case PostTileType.compact:
      margin = "my-1";
      padding = "p-2";
      displayThirdLine = false;
      break;

    default:
      margin = "my-3";
      padding = "p-4";
      break;
  }

  if (type === PostTileType.expanded) {
    return <ExpandPost />;
  }

  return (
    <div id={type} className={cn(cx(margin, "rounded", padding), className)}>
      {/* User Tile */}
      <div className="flex place-items-center">
        <p className="h-8 w-8 rounded-full bg-muted/80"></p>
        <div className="ml-2 w-max space-y-1">
          <p className="h-2 w-16 rounded bg-muted/80"></p>
          <div className="mt-2 h-2 w-8 rounded bg-muted/80" />
        </div>
      </div>

      {/* Description */}
      <div className="mt-3 h-2 w-[64%] rounded bg-muted/80" />
      <div className="mt-2 h-2 w-[32%] rounded bg-muted/80" />
      {displayThirdLine ? (
        <div className="mt-4 h-2 w-[48%] rounded bg-muted/80" />
      ) : null}

      {/* Like comment shimmer */}

      <div>
        <div className="mt-3 h-0.5 w-full rounded bg-gray-100" />
        <div className="flex place-items-center">
          <div className="mt-2 h-4 w-4 rounded border-2 border-border bg-gray-200" />
          <div className="m-l-2 ml-2 mt-2 h-3 w-12 rounded bg-gray-200" />

          <div className="ml-6 mt-2 h-4 w-4 rounded bg-gray-200" />
          <div className="m-l-2 ml-2 mt-2 h-3 w-12 rounded bg-gray-200" />
        </div>
      </div>
    </div>
  );

  function ExpandPost({ className = "" }) {
    return (
      <div className={cn(cx("my-3 rounded px-6 pt-4", className))}>
        {/* User Tile */}
        <div className="flex place-items-center">
          <p className="h-8 w-8 rounded-full bg-muted/80"></p>
          <div className="ml-2 w-max space-y-1">
            <p className="h-2 w-16 rounded bg-muted/80"></p>
            <div className="mt-2 h-2 w-8 rounded bg-muted/80" />
          </div>
        </div>

        {/* Space */}
        <div className="my-6" />

        {/* Description */}
        <div className="mt-2 h-2 w-1/3 rounded bg-muted/80" />
        <div className="mt-2 h-2 w-1/2 rounded bg-muted/80" />
        <div className="mt-4 h-2 rounded bg-muted/80" />

        {/* Space */}
        <div className="h-5" />

        {/* Like comment shimmer */}
        <div className="flex space-x-4">
          <div className="mt-2 h-2 w-16 rounded bg-muted/80" />
          <div className="mt-2 h-2 w-16 rounded bg-muted/80" />
        </div>
        <div>
          {/* Divider */}
          {/* <div className="w-full h-0.5 bg-gray-100 rounded mt-6" /> */}

          {/* Action Button */}
          <div className="border0border my-4 flex place-items-center border-t py-2">
            <div className="mt-2 h-4 w-4 rounded bg-muted/80" />
            <div className="m-l-2 ml-2 mt-2 h-3 w-12 rounded bg-muted/80" />

            <div className="ml-6 mt-2 h-4 w-4 rounded bg-muted/80" />
            <div className="m-l-2 ml-2 mt-2 h-3 w-12 rounded bg-muted/80" />
          </div>
        </div>
      </div>
    );
  }
}

export default PostTileShimmer;
